import type { SchemaFieldIconType } from '@rossum/components/schema-field-icon/SchemaFieldIcon';
import { properValueSourceOptions } from '../fields/constants';

// Accepts string to support rule/hook node types added in follow-up MRs.
export const fieldIconType = (type: string): SchemaFieldIconType | null =>
  properValueSourceOptions.find(option => option === type) ?? null;
